module.exports = __webpack_public_path__ + "img/mp4.27703ba4.svg";